import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Button from '@mui/material/Button';

const StyledButton = styled(Button)(({ theme }) => ({
  overflow: 'hidden',
  margin: theme.spacing(1),
  maxHeight: theme.spacing(6),
  borderRadius: theme.spacing(1),
  boxShadow: 'none',
  transition: theme.transitions.create('transform'),
  '&:hover': {
    transform: 'translateY(-3px)',
  },
  '&.disabled': {
    background: theme.palette.error.light,
  },
  '& .label': {
    textTransform: 'initial',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  '& .bold': {
    fontWeight: theme.typography.fontWeightBold,
  },
}));

const CommonButton = ({
  label,
  size,
  onClick,
  icon,
  iconOnRight,
  type,
  disabled,
  isLabelBold,
  isAnimated,
  leftAdornment,
  ...rest
}) => {
  const buttonSize = size || 'medium';

  return (
    <StyledButton
      {...rest}
      size={buttonSize}
      type={type}
      disabled={disabled}
      onClick={onClick}
      sx={{
        transform: isAnimated ? 'translateY(-3px)' : 'none',
        '&:hover': {
          transform: isAnimated ? 'translateY(-3px)' : 'none',
        },
        backgroundColor: disabled ? 'error.light' : undefined,
      }}
    >
      {leftAdornment && leftAdornment}
      {!iconOnRight && icon}
      <span style={{ fontWeight: isLabelBold ? 'bold' : 'normal' }}>{label}</span>
      {iconOnRight && icon}
    </StyledButton>
  );
};

CommonButton.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  color: PropTypes.string,
  size: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.object,
  iconOnRight: PropTypes.bool,
  variant: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  isLabelBold: PropTypes.bool,
  isAnimated: PropTypes.bool,
  leftAdornment: PropTypes.node,
};

CommonButton.defaultProps = {
  color: 'primary',
  variant: 'contained',
};

export default CommonButton;
